export default {
  en: {
    headerTitle: 'Scenario',
    notFoundTitle: 'Scenario not found',
    notFoundMessage: 'This roleplay no longer exists — it may have been removed or renamed.',
    notFoundRetryLabel: 'Go home',
    startButton: 'Start conversation',
    loadingSr: 'Loading scenario',
  },
  ru: {
    headerTitle: 'Ситуация',
    notFoundTitle: 'Сценарий не найден',
    notFoundMessage: 'Такой ролевой игры больше нет — возможно, её убрали или переименовали.',
    notFoundRetryLabel: 'На главную',
    startButton: 'Начать диалог',
    loadingSr: 'Загружаем сценарий',
  },
  de: {
    headerTitle: 'Szenario',
    notFoundTitle: 'Szenario nicht gefunden',
    notFoundMessage: 'Dieses Rollenspiel existiert nicht mehr — es wurde vielleicht entfernt oder umbenannt.',
    notFoundRetryLabel: 'Zur Startseite',
    startButton: 'Dialog starten',
    loadingSr: 'Szenario wird geladen',
  },
  pt: {
    headerTitle: 'Cenário',
    notFoundTitle: 'Cenário não encontrado',
    notFoundMessage: 'Esse jogo de papéis não existe mais — talvez tenha sido removido ou renomeado.',
    notFoundRetryLabel: 'Ir para o início',
    startButton: 'Iniciar diálogo',
    loadingSr: 'Carregando cenário',
  },
  fr: {
    headerTitle: 'Scénario',
    notFoundTitle: 'Scénario introuvable',
    notFoundMessage: 'Ce jeu de rôle n’existe plus — il a peut-être été supprimé ou renommé.',
    notFoundRetryLabel: 'Retour à l’accueil',
    startButton: 'Lancer le dialogue',
    loadingSr: 'Chargement du scénario',
  },
  es: {
    headerTitle: 'Escenario',
    notFoundTitle: 'Escenario no encontrado',
    notFoundMessage: 'Este juego de rol ya no existe — puede que se haya eliminado o renombrado.',
    notFoundRetryLabel: 'Ir al inicio',
    startButton: 'Iniciar diálogo',
    loadingSr: 'Cargando escenario',
  },
};
